import axios from "axios";
import qs from "qs";
import Config from "../config";
import { getToken } from "./service";
import _ from "underscore";

export enum VoteType {
    Single = 0, // 单选
    Multiple = 1, // 多选
    Judge = 2 // 判断
}

export enum VoteState {
    Idle = 0, // 未开启
    InProgress = 1, // 进行中
    Done = 2 // 结束
}

export const VoteTypeMap = {
    [VoteType.Single]: "单选",
    [VoteType.Multiple]: "多选",
    [VoteType.Judge]: "判断"
};

export const VoteStateMap = {
    [VoteState.Idle]: "未开始",
    [VoteState.InProgress]: "进行中",
    [VoteState.Done]: "已结束"
};

interface VoteForm {
    id?: number;
    title: string;
    weekTimeId: number;
    validityTime: number;
    type: VoteType; // 投票类型0:单选1:多选2:判断
    answersNumber?: number; // 选项个数  (判断题不传)
    status?: VoteState; // 投票状态 新增不传，修改传
}

/**
 * 创建/修改投票
 * @param data
 */
export function addOrUpdateVoteTactics(data: VoteForm) {
    const token = getToken();
    const formData = {
        ...data,
        validityTime: data.validityTime === 0 ? undefined : data.validityTime
    };
    return axios.post<SuccessData<number>>(
        "/teacher/vote/addOrUpdateVoteTactics",
        qs.stringify(formData),
        { headers: { token } }
    );
}

export interface VoteItem {
    id: number;
    title: string;
    validityTime: number;
    startTime: string;
    endTime: string;
    status: VoteState;
    type: VoteType;
    answersNumber: number;
    courseStuCount: number;
    voteStuCount: number;
    notVoteStuCount: number;
}

/**
 * 教师投票列表
 * @param weekTimeId
 */
export function getVoteList(weekTimeId: number) {
    const token = getToken();
    return axios
        .post<SuccessData<VoteItem[]>>(
            "/teacher/vote/VoteList",
            qs.stringify({ weekTimeId }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 发布投票
 * @param votePaperId
 */
export function publishVotePaper(votePaperId: number) {
    const token = getToken();
    return axios.post(
        "/teacher/vote/publishVotePaper",
        qs.stringify({ votePaperId }),
        { headers: { token } }
    );
}

/**
 * 结束投票
 * @param votePaperId
 */
export function endVote(votePaperId: number) {
    const token = getToken();
    return axios.post("/teacher/vote/endVote", qs.stringify({ votePaperId }), {
        headers: { token }
    });
}

/**
 * 删除投票
 * @param weekTimeId
 * @param votePaperId
 */
export function deleteVotePaper(weekTimeId: number, votePaperId: number) {
    const token = getToken();
    return axios.post(
        "/teacher/vote/deleteVotePaper",
        qs.stringify({ weekTimeId, votePaperId }),
        { headers: { token } }
    );
}

export interface VoteInfo {
    id: number;
    title: string;
    validityTime: number;
    startTime: string;
    endTime: string;
    status: VoteState;
    type: VoteType;
    answersNumber: number;
}

/**
 * 投票设置反显数据
 * @param votePaperId
 */
export function votePaperInfo(votePaperId: number) {
    const token = getToken();
    return axios
        .post<SuccessData<VoteInfo>>(
            "/teacher/vote/votePaperInfo",
            qs.stringify({ votePaperId }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

export interface VoteContent {
    id: number;
    title: string;
    validityTime: number;
    startTime: string;
    endTime: string;
    status: VoteState;
    type: VoteType;
    answersNumber: number;
    time: string;
    percentage: string;
}

/**
 * 投票详情的投票明细
 * @param votePaperId
 */
export function getVotePaperContent(votePaperId: number) {
    const token = getToken();
    return axios
        .post<SuccessData<VoteContent>>(
            "/teacher/vote/getVotePaperContent",
            qs.stringify({ votePaperId }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

export interface StuVoteItem {
    className: string;
    name: string;
    studentNo: string;
    voteTime: string;
    voteStatus: string;
    department: string;
    subject: string;
    voteInfo?: {
        content: string;
    }[];
}

/**
 * 投票详情的投票明细
 * @param votePaperId
 */
export function voteInfoList(votePaperId: number) {
    const token = getToken();
    return axios
        .post<SuccessData<StuVoteItem[]>>(
            "/teacher/vote/voteInfoList",
            qs.stringify({ votePaperId }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 统计投票结果
 * @param type
 * @param answersNumber
 * @param list
 */
export function getResultFromVoteList(
    type: VoteType,
    answersNumber: number,
    list: StuVoteItem[]
) {
    const answers = _.sortBy(
        _.pluck(_.flatten(_.compact(_.pluck(list, "voteInfo"))), "content")
    );

    const data = _.map(
        _.groupBy(answers, item => item),
        (item, text) => ({ count: item.length, text })
    );

    if (type === VoteType.Judge) {
        return [
            {
                count: _.find(data, item => item.text === "YES")?.count || 0,
                text: "YES"
            },
            {
                count: _.find(data, item => item.text === "NO")?.count || 0,
                text: "NO"
            }
        ];
    } else {
        return new Array(answersNumber).fill(0).map((item, index) => {
            console.log(index);
            const text = String.fromCharCode(index + 65);
            console.log(text);
            return {
                count:
                    _.find(data, item => item.text.toUpperCase() === text)
                        ?.count || 0,
                text: text
            };
        });
    }
}

/**
 * 导出投票结果
 */
export function exportVote(votePaperId: number) {
    const token = getToken();
    window.open(
        `${Config.ApiHost}/teacher/vote/exportVote?${qs.stringify({
            votePaperId,
            token
        })}`
    );
}

/**
 * 获取筛选项
 */
export function getVoteFilter(
    type: VoteType,
    answersNumber: number,
    stuList: StuVoteItem[]
) {
    const options = getResultFromVoteList(type, answersNumber, []).map(
        item => item.text
    );

    let allOptions: any[];

    if (type !== VoteType.Multiple) {
        const selected = _.chain(stuList)
            .filter(item => item.voteStatus === "1" && !!item.voteInfo)
            .pluck("voteInfo")
            .map(item => item?.[0].content)
            .compact()
            .value();

        allOptions = _.intersection(options, selected).map(item => ({
            text: item,
            value: item
        }));
    } else {
        allOptions = options.map(item => ({ text: item, value: item }));
    }

    allOptions.unshift({ text: "--", value: "--" });

    return allOptions;
}
